<a class="view-contents-button" [glxyPopover]="popover" (click)="togglePopover()" data-cy="show-contents-button">
  Package (view contents)
</a>

<glxy-popover
  #popover
  [(isOpen)]="isOpen"
  [positions]="[PopoverPositions.Bottom, PopoverPositions.Top]"
  [hasArrow]="true"
  [keepOnScreen]="true"
  [padding]="'none'"
  [closeOnBackdropClick]="true"
  [closeOnEscapeKey]="true"
>
  <div class="item-list-container">
    <ng-container *ngIf="packageItems$ | async as packageItems; else loadingSpinner">
      <inventory-ui-item-list [items]="packageItems" />
    </ng-container>
  </div>
</glxy-popover>

<ng-template #loadingSpinner>
  <glxy-loading-spinner [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
</ng-template>
